export default __webpack_public_path__ + "static/media/P-007.1d9b9524.png";